import { createAction, handleActions } from 'redux-actions';
import { Map, List, fromJS } from 'immutable';
import React from "react";

// action types
const SET_IMAGE_TYPE = 'campaignImage/SET_IMAGE_TYPE';
const SET_SORT_BY = 'campaignImage/SET_SORT_BY';
const SET_PAGE = 'campaignImage/SET_PAGE';

const SET_TOTAL = 'campaignImage/SET_TOTAL';
const SET_IMAGES = 'campaignImage/SET_IMAGES';

const SET_IMAGE_DELETE_UID_LIST = 'campaignImage/SET_IMAGE_DELETE_UID_LIST';

const SET_IMG_FILE = 'campaignImage/SET_IMG_FILE';
const SET_IMG_NAME = 'campaignImage/SET_IMG_NAME';
const RESET_IMAGE_UPLOAD_PARAMS = 'campaignImage/RESET_IMAGE_UPLOAD_PARAMS';

// action creators
export const setImageType = createAction(SET_IMAGE_TYPE);
export const setSortBy = createAction(SET_SORT_BY);
export const setPage = createAction(SET_PAGE);

export const setTotal = createAction(SET_TOTAL);
export const setImages = createAction(SET_IMAGES);

export const setImageDeleteUidList = createAction(SET_IMAGE_DELETE_UID_LIST);

export const setImgFile = createAction(SET_IMG_FILE);
export const setImgName = createAction(SET_IMG_NAME);
export const resetImgUploadParams = createAction(RESET_IMAGE_UPLOAD_PARAMS);

// initial state
const initialState = Map( {
    imageType: 'RCS',
    sortBy: 'date',
    page: 1,
    size: 10,

    total: 0,
    images: [],

    imageDeleteUidList: [],

    imgFile: null,
    imgName: "",
})

// reducer
export default handleActions({
    [SET_IMAGE_TYPE]: (state, action) => {
        const imageType = action.payload;
        return state.set('imageType', imageType);
    },
    [SET_SORT_BY]: (state, action) => {
        const sortBy = action.payload;
        return state.set('sortBy', sortBy);
    },
    [SET_PAGE]: (state, action) => {
        const page = action.payload;
        return state.set('page', page);
    },

    [SET_TOTAL]: (state, action) => {
        const total = action.payload;
        return state.set('total', total);
    },
    [SET_IMAGES]: (state, action) => {
        const images = action.payload;
        return state.set('images', images);
    },

    [SET_IMAGE_DELETE_UID_LIST]: (state, action) => {
        const imageDeleteUidList = action.payload;
        return state.set('imageDeleteUidList', imageDeleteUidList);
    },

    [SET_IMG_FILE]: (state, action) => {
        const imgFile = action.payload;
        return state.set('imgFile', imgFile);
    },
    [SET_IMG_NAME]: (state, action) => {
        const imgName = action.payload;
        return state.set('imgName', imgName);
    },
    [RESET_IMAGE_UPLOAD_PARAMS]: (state, action) => {
        return state
            .set('imgName', '')
            .set('imgFile', '');
    },
}, initialState)
